import { TrackingManager } from '@benzinga/tracking-manager';
import { getSessionSingleton } from '@benzinga/session';

export const handleMenuItemsClickEvent = (action, category, label) => {
  const session = getSessionSingleton();
  session.getManager(TrackingManager).trackLinkEvent('click', {
    //'menu_click', //action
    link_action: action,
    link_id: label,
    link_type: category,
  });
};
